<template>
  <el-container type="flex" class="container">
    <el-main>
      <el-table
        :data="identity_apply_list"
        stripe
        border
        style="width: 100%"
        v-loading="tableLoading"
        :header-cell-style="{background:'#EBEEF5',color:'black'}"
        >
          <el-table-column
            fixed
            prop="apply_time"
            align="center"
            width="200"
            label="申请时间">
          </el-table-column>
          <el-table-column
            prop="phone"
            align="center"
            width="200"
            label="申请者手机号">
          </el-table-column>
        <el-table-column
          align="center"
          width="200"
          label="来源">
          <template v-slot="scope">
            <div>{{ scope.row.from === 1 ? '小程序' : '团小蜜后台登录页' }}</div>
          </template>
        </el-table-column>
          <el-table-column align="center" label="操作">
            <template v-slot="scope" >
              <el-button v-show="scope.row.from === 1" type="primary" @click="agreeApply(scope.row, 1)">同意成为团长</el-button>
              <el-button v-show="scope.row.from === 1" type="primary" @click="agreeApply(scope.row, 2)">同意成为品牌商</el-button>
              <el-input v-model="scope.row.note" v-show="scope.row.wantEdit" placeholder="备注" style="width:300px;" @blur="setNote(scope.row)" @keyup.enter.native="setNote(scope.row)"></el-input>
              <div v-if="!scope.row.wantEdit" @click="wantEdit(scope.row)">{{ scope.row.note || '暂无备注' }}</div>
            </template>
          </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer">
      <el-pagination
        :total="totalCount"
        :page-size="pagesize"
        :current-page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </el-footer>
  </el-container>

</template>

<script>
import pageMixin from '../../../mixins/page'
import getTokenMixin from '../../../mixins/getToken'
export default {
  name: 'BecomePayingUser',
  mixins: [pageMixin, getTokenMixin],
  data () {
    return {
      AapplyListURL: this.getDomain() + 'bmidentityapply/get_apply_list',
      identityOperateURL: this.getDomain() + 'bmidentityapply/identity_operate',
      setApplyNoteURL: this.getDomain() + 'bmidentityapply/set_apply_note',
      identity_apply_list: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      this.tableLoading = true
      let params = {
        page: this.page,
        pagesize: this.pagesize,
        type: 0
      }
      let handle = res => {
        this.totalCount = res.data.content.total
        this.identity_apply_list = res.data.content.identity_apply_list
        this.identity_apply_list.forEach(item => {
          item.apply_time = this.timeTransform(item.apply_time)
          this.$set(item, 'wantEdit', false)
        })
        this.tableLoading = false
      }
      this.__axios(this.AapplyListURL, params, handle)
    },

    agreeApply (row, type) {
      let params = {
        identity_apply_id: row.identity_apply_id,
        type: type
      }
      let handle = res => {
        this.$message.success('操作成功')
        this.getList()
      }
      this.__axios(this.identityOperateURL, params, handle)
    },

    setNote (row) {
      let params = {
        identity_apply_id: row.identity_apply_id,
        note: row.note
      }
      let handle = res => {
        this.$message.success('操作成功')
        this.getList()
      }
      this.__axios(this.setApplyNoteURL, params, handle)
    },

    wantEdit (row) {
      row.wantEdit = true
    }
  }

}
</script>

<style scoped>
  .container {
    padding: 30px 20px;
  }

</style>
